import type { Translation } from '../types.ts';
import type en from '../en/index.ts';

import common from './common.ts';
import shell from './shell.ts';
import auth from './auth.ts';
import account from './account.ts';
import dashboard from './dashboard.ts';
import users from './users.ts';
import ui from './ui.ts';
import websites from './websites.ts';
import settings from './settings.ts';
import backups from './backups.ts';
import themes from './themes.ts';
import pages from './pages.ts';
import menus from './menus.ts';
import redirects from './redirects.ts';
import editor from './editor.ts';
import seo from './seo.ts';
import articles from './articles.ts';
import faq from './faq.ts';
import portfolio from './portfolio.ts';
import landing from './landing.ts';
import media from './media.ts';
import forms from './forms.ts';
import submissions from './submissions.ts';
import newsletter from './newsletter.ts';
import reviews from './reviews.ts';
import abandonedCarts from './abandonedcarts.ts';
import products from './products.ts';
import categories from './categories.ts';
import imports from './imports.ts';
import orders from './orders.ts';
import customers from './customers.ts';
import giftcards from './giftcards.ts';
import discounts from './discounts.ts';
import shipping from './shipping.ts';
import checkout from './checkout.ts';
import tax from './tax.ts';
import closure from './closure.ts';
import delivery from './delivery.ts';
import stats from './stats.ts';
import bol from './bol.ts';
import snelstart from './snelstart.ts';
import vehicles from './vehicles.ts';
import transfer from './transfer.ts';

export default {
    common,
    shell,
    auth,
    account,
    dashboard,
    users,
    ui,
    websites,
    settings,
    backups,
    themes,
    pages,
    menus,
    redirects,
    editor,
    seo,
    articles,
    faq,
    portfolio,
    landing,
    media,
    forms,
    submissions,
    newsletter,
    reviews,
    abandonedCarts,
    products,
    categories,
    imports,
    orders,
    customers,
    giftcards,
    discounts,
    shipping,
    checkout,
    tax,
    closure,
    delivery,
    stats,
    bol,
    snelstart,
    vehicles,
    transfer,
} satisfies Translation<typeof en>;
